import { Phone, Mail, MapPin, Instagram, Facebook, ExternalLink } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { useT } from "../../i18n/LanguageContext";

const INSTA = "https://www.instagram.com/mexihome5/";
const FB = "https://www.facebook.com/profile.php?id=61589255567597";

export default function Footer() {
  const { t } = useT();
  return (
    <footer className="bg-[#0a1432] text-[#faf6ee]" data-testid="site-footer">
      <div className="azulejo-band" aria-hidden="true" />

      {/* Social row with QR codes */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-[10px] uppercase tracking-[0.22em] text-[#e3b25b]">{t.footer.followUs}</p>
            <h3 className="font-display text-3xl md:text-4xl mt-2">
              {t.footer.followTitle1} <em className="text-[#e3b25b]">{t.footer.followTitle2}</em>
            </h3>
            <p className="mt-3 text-sm text-white/70 max-w-md">{t.footer.followSubtitle}</p>

            <div className="mt-6 flex flex-wrap gap-3">
              <a href={INSTA} target="_blank" rel="noreferrer" data-testid="footer-insta" className="flex items-center gap-2 bg-white/10 hover:bg-[#e3b25b] hover:text-[#0a1432] transition px-5 py-2.5 rounded-full text-sm font-semibold">
                <Instagram size={16} /> Instagram <ExternalLink size={12} />
              </a>
              <a href={FB} target="_blank" rel="noreferrer" data-testid="footer-fb" className="flex items-center gap-2 bg-white/10 hover:bg-[#e3b25b] hover:text-[#0a1432] transition px-5 py-2.5 rounded-full text-sm font-semibold">
                <Facebook size={16} /> Facebook <ExternalLink size={12} />
              </a>
            </div>
          </div>

          <div className="flex flex-wrap justify-center md:justify-end gap-5">
            <a href={INSTA} target="_blank" rel="noreferrer" className="block group" data-testid="footer-qr-insta">
              <div className="bg-[#faf6ee] rounded-2xl p-3 shadow-xl ring-1 ring-[#e3b25b]/30 group-hover:scale-105 transition">
                <QRCodeSVG value={INSTA} size={128} fgColor="#0e1a3f" bgColor="#faf6ee" level="M" className="block w-32 h-32" aria-label="QR Instagram MexiHome5" />
              </div>
              <p className="text-center text-[10px] uppercase tracking-[0.2em] text-[#e3b25b] mt-2 flex items-center justify-center gap-1">
                <Instagram size={11} /> @mexihome5
              </p>
            </a>
            <a href={FB} target="_blank" rel="noreferrer" className="block group" data-testid="footer-qr-fb">
              <div className="bg-[#faf6ee] rounded-2xl p-3 shadow-xl ring-1 ring-[#e3b25b]/30 group-hover:scale-105 transition">
                <QRCodeSVG value={FB} size={128} fgColor="#0e1a3f" bgColor="#faf6ee" level="M" className="block w-32 h-32" aria-label="QR Facebook MexiHome5" />
              </div>
              <p className="text-center text-[10px] uppercase tracking-[0.2em] text-[#e3b25b] mt-2 flex items-center justify-center gap-1">
                <Facebook size={11} /> MexiHome5
              </p>
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src="/assets/logo.jpg" alt="MexiHome5" className="w-14 h-14 rounded-full object-cover ring-2 ring-[#e3b25b]/40" />
            <div>
              <p className="font-script text-3xl">MexiHome<span className="text-[#e3b25b]">5</span></p>
              <p className="text-[10px] uppercase tracking-[0.2em] italic text-white/60">Alojamento Local · Algarve</p>
            </div>
          </div>
          <p className="mt-5 text-sm text-white/65 max-w-md leading-relaxed">{t.footer.tagline}</p>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4 text-[#e3b25b]">{t.footer.contacts}</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 text-[#e3b25b]" /> <a href="tel:+351965209781" className="hover:underline">+351 965 209 781 (Carlos)</a></li>
            <li className="flex items-start gap-2"><Phone size={16} className="mt-0.5 text-[#e3b25b]" /> <a href="tel:+351965488960" className="hover:underline">+351 965 488 960 (Rute)</a></li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5 text-[#e3b25b]" /> <a href="mailto:mexihome5@hotmail.com" className="hover:underline break-all">mexihome5@hotmail.com</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4 text-[#e3b25b]">{t.footer.address}</h4>
          <p className="text-sm text-white/75 flex items-start gap-2">
            <MapPin size={16} className="mt-0.5 text-[#e3b25b]" />
            Rua Valeriano João da Glória, Nº 5<br />
            8500-132 Mexilhoeira Grande<br />
            Algarve · Portugal
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/55">
          <p>© {new Date().getFullYear()} MexiHome5 · {t.footer.rights}</p>
          <p>{t.footer.madeIn}</p>
        </div>
      </div>
    </footer>
  );
}
